<template>
    <div :key="route.path">
        <LayoutMetaData
            :title="title"
            :meta="meta"
        />
        <LayoutContentRouter
            :content="pageData"
        />
    </div>
</template>
<script setup>
import { useRoute, usePageLoad } from '#imports';
import { usePageStore } from '~dsc/stores/cms/page';
import { storeToRefs } from 'pinia';

const route = useRoute();
const { pageTitle: title, meta, pageData } = storeToRefs(usePageStore());

if (import.meta.client) {
    try {
        await usePageLoad(route);
    } catch (error) {
        console.error('Page load failed:', error);
    }
}
</script>
